module.exports = __webpack_public_path__ + "img/search.a4bac49c.svg";